import '../vendor/triton-player-sdk/2.9.41/td-sdk.min.js';

import {Triton_Livestream_Player} from './Triton_Livestream_Player';

new Triton_Livestream_Player('livestream_player');